import {AElement} from "./AElement";
import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export class SolarPanel extends AElement {

    constructor(serialNumber: string, isScanned?: boolean) {
        super(EElementType.SolarPanel, serialNumber, isScanned, ModelsRegExp.elementSerialNumberSolarPanel);
    }

    public static remapObjectToElement(object: any): SolarPanel | null {
        let element: SolarPanel | null = null;
        if(
            object._serialNumber
        ) {
            element = new SolarPanel(
                object._serialNumber,
                object._isScanned
            );
        }
        return element;
    }

}


